import Model from '@/class/cargo/model/utils/Model'

export class PriceFclDataType {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'PriceFclDataType'

export const PRC_DATE_ETD = new PriceFclDataType(1, 'ETD', '开船日期')

export const PRC_DATE_CUSTOMCUTOFF = new PriceFclDataType(2, 'CustomCutoff', '截关日期')

export const PRC_DATE_TERMINALCUTOFF = new PriceFclDataType(3, 'ReturnPeriod', '还柜日期')

// 运价日期类型
export const PRC_DATE_TYPE = [PRC_DATE_ETD, PRC_DATE_CUSTOMCUTOFF, PRC_DATE_TERMINALCUTOFF]

/**
		 *  return null:没找到.
		 */
export function getPriceFclDataTypeByCode(code) {
  return Model.getObjByCode(code, PRC_DATE_TYPE)
}
